








































import { Component, Inject, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  ITransactionsProvider,
  ITransactionsProviderMethods
} from "@/models/providers/transactions";

@Component({
  components: {
    "transactions-items": () =>
      import("@/components/app/admin/transactions/transactionsItems.vue")
  }
})
export default class TransactionsListing extends Mixins(Context) {
  // Inject

  @Inject({ from: "transactionsProvider" })
  public transactionsProvider!: () => ITransactionsProvider;

  @Inject({ from: "transactionsProviderMethods" })
  public $transactionsMethods!: ITransactionsProviderMethods;

  // Computed

  public get transactionsData() {
    return this.transactionsProvider();
  }

  public get resultsIncludeRecentRefunds() {
    return this.transactionsData.resultsIncludeRecentRefunds;
  }
}
